import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebhooksMessageAttempt } from '../../models/WebhooksMessageAttempt';

@Component({
  standalone: false,
  selector: 'odin-callback-transaction-modal',
  styleUrls: ['./callback-transaction-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './callback-transaction-modal.component.html'
})
export class CallbackTransactionModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: WebhooksMessageAttempt) {}


  copyCallbackResponse() {
    navigator.clipboard.writeText(this.data.response || '')
      .then(() => alert('Full response copied to clipboard!'))
      .catch(err => alert('Failed to copy response.'));
  }
}